<template>
  <span
    v-for="(source, index) in alarmSources"
    :key="index"
    :class="'badge text-bg-' + tagSeverityToBadgeClass(source.severity) + ' ms-badge'"
    >{{ renderType(source.type) }}</span
  >
</template>

<script setup lang="ts">
import { AlarmSource, AlarmSourceType, AlarmSeverity } from '@/server/MakeSenseApp-backend'
import { defineProps } from 'vue'

defineProps({
  alarmSources: Array<AlarmSource>
})

function renderType(type?: AlarmSourceType) {
  if (type === AlarmSourceType.SpareParts) {
    return 'Inventory'
  }

  return type
}

function tagSeverityToBadgeClass(severity?: AlarmSeverity) {
  if (severity === undefined) {
    return
  }
  switch (severity) {
    case AlarmSeverity.LowSeverity:
      return 'secondary'
    case AlarmSeverity.MediumSeverity:
      return 'warning'
    case AlarmSeverity.HighSeverity:
      return 'danger'
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.ms-badge {
  margin-right: 5px;
  border-radius: 0px;
}

.ms-badge.badge.text-bg-danger {
  background-color: color.$color-error !important;
}

.ms-badge.badge.text-bg-warning {
  background-color: color.$color-warning-base !important;
  color: #ffffff !important;
}

.ms-badge.badge.text-bg-secondary {
  background-color: color.$color-dark-grey !important;
}
</style>
